export type SseTranslation = {
  toast: {
    connectionError: string;
    connectionReestablished: string;
  };
};
export const sseTranslation: SseTranslation = {
  toast: {
    connectionError: 'Błąd połączenia. Twoje wiadomości nie są automatycznie aktualizowane.',
    connectionReestablished:
      'Połączenie zostało wznowione. Twoje wiadomości są automatycznie aktualizowane.',
  },
};
